import { render, staticRenderFns } from "./DocumentDropoff.vue?vue&type=template&id=7e1b1618"
import script from "./DocumentDropoff.vue?vue&type=script&lang=js"
export * from "./DocumentDropoff.vue?vue&type=script&lang=js"
import style0 from "./DocumentDropoff.vue?vue&type=style&index=0&id=7e1b1618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports